import React, { type ReactNode } from "react";
import { FormattedMessage } from "react-intl";

export const length = (
  minChars?: number,
  maxChars?: number,
  {
    tooShortMessage,
    tooLongMessage,
  }: {
    tooShortMessage?: ReactNode;
    tooLongMessage?: ReactNode;
  } = {},
) => {
  return (value: any) => {
    if (typeof value !== "string" || value === "") {
      return undefined;
    }

    if (minChars !== undefined && value.length < minChars) {
      return (
        tooShortMessage ?? (
          <FormattedMessage
            id="form.validations.length.too_short"
            values={{ minChars }}
          />
        )
      );
    }

    if (maxChars !== undefined && value.length > maxChars) {
      return (
        tooLongMessage ?? (
          <FormattedMessage
            id="form.validations.length.too_long"
            values={{ maxChars }}
          />
        )
      );
    }

    return undefined;
  };
};
